import React, { useEffect, useMemo } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import MainLayout from "../../../../layouts/MainLayout";
import "../../../../assets/styles/custom-styles.css";
import DetailsSectionRenderer from "../../../../components/DetailsSectionRenderer";
import { detailsContactFields } from "../../../../constants/forms/contactFields";
import useLoader from "../../../../hooks/useLoader";
import useNotification from "../../../../hooks/useNotification";
import useForm from "../../../../hooks/useForm";
import { setDefaultFieldValues } from "../../../../utils/objectUtils";
import useBaseService from "../../../../hooks/services/useBaseService";
import { entities } from "../../../../constants/entities";
import PageHeader from "../../../../components/PageHeader";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import useQueryWithLoader from "../../../../hooks/useQueryWithLoader";

const SupplierContactDetailsPage = () => {
  const navigate = useNavigate();
  const { id, contactId } = useParams();
  const location = useLocation();
  const queryClient = useQueryClient();

  const { showLoader, hideLoader } = useLoader();
  const { showNotification } = useNotification();
  const { getByColumn: fetchById } = useBaseService(navigate);

  const { formData, formatData } = useForm(
    setDefaultFieldValues(detailsContactFields),
  );

  const {
    data: contactData,
    isLoading: isLoadingContact,
    isError: isErrorContact,
    error: contactError,
  } = useQueryWithLoader({
    queryKey: ["equipment_supplierContact", id, contactId],
    queryFn: async () => {
      showLoader();
      const response = await fetchById(
        entities.suppliers.contacts.getById(id, contactId),
      );
      return response.result;
    },
    staleTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    if (!isLoadingContact && !isErrorContact && !contactError && contactData) {
      formatData(contactData, detailsContactFields);
      hideLoader();
    }
    if (isErrorContact || contactError) {
      showNotification(
        "error",
        `Erro ao carregar detalhes do contato: ${
          contactError.response?.data?.message || contactError.message
        }`,
      );
      hideLoader();
      navigate(`/aluguel/fornecedores/detalhes/${id}`, {
        replace: true,
        state: {
          type: "error",
          message: "Contato não encontrado ou erro ao carregar.",
        },
      });
    }
  }, [isLoadingContact, isErrorContact, contactError, contactData]);

  useEffect(() => {
    if (location.state?.message) {
      showNotification(location.state.type, location.state.message);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, showNotification, navigate, location.pathname]);

  return (
    <MainLayout selectedCompany="ALUCOM">
      <PageHeader
        title="Detalhes do Contato do Fornecedor"
        showBackButton={true}
        backUrl={`/aluguel/fornecedores/detalhes/${id}`}
      />
      <div className="container-fluid p-1">
        <DetailsSectionRenderer
          sections={detailsContactFields}
          formData={formData}
          isLoading={isLoadingContact}
          readOnly={true}
        />
      </div>
    </MainLayout>
  );
};

export default SupplierContactDetailsPage;
